import Axios from "axios";
import { authorizationHeader } from "./apiUtils";
import { Filter } from "../models/misc";

const baseRoute = "/api/filters";

export async function getAllFilters(): Promise<Filter[]> {
  const resp = await Axios.get<Filter[]>(
    baseRoute,
    { headers: authorizationHeader() }
  );
  return resp.data;
}

export async function getFilter(filterId: number): Promise<Filter> {
  const resp = await Axios.get<Filter>(
    `${baseRoute}/${filterId}`,
    { headers: authorizationHeader() }
  );
  return resp.data;
}

export async function createFilter(filter: Partial<Filter>): Promise<Filter> {
  const resp = await Axios.post<Filter>(
    baseRoute,
    filter,
    { headers: authorizationHeader() }
  );
  return resp.data;
}

export async function updateFilter(filter: Filter): Promise<void> {
  await Axios.put(
    `${baseRoute}/${filter.filterId}`,
    filter,
    { headers: authorizationHeader() }
  );
}

export async function deleteFilter(filterId: number): Promise<void> {
  await Axios.delete(
    `${baseRoute}/${filterId}`,
    { headers: authorizationHeader() }
  );
}
